import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './auth/Login';
import ProjectList from './components/ProjectList';
import ProjectAI from './components/ProjectAI';
import { useAuth } from './context/AuthContext';

function App() {
  const { user } = useAuth();

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/projects" element={user ? <ProjectList /> : <Navigate to="/login" />} />
      <Route path="/projects/:projectName" element={user ? <ProjectAI /> : <Navigate to="/login" />} />
      <Route path="*" element={<Navigate to="/projects" />} />
    </Routes>
  );
}

export default App;
